import React, { useEffect, useState } from 'react';
import '../../css/LeaveQuota.css';
import { useTranslation } from 'react-i18next';
import UpdateLeaveForm from './LeaveEditForm';
import { faPen,  faCircleArrowDown } from '@fortawesome/free-solid-svg-icons';
import {  faTrashCan } from '@fortawesome/free-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isMobile } from 'react-device-detect';
import Swal from 'sweetalert2';

const loadingGif = process.env.REACT_APP_PUBLIC_URL + '/loading1.gif';

const UpdateLeave = ({ data, language, onSendMessage, isDisabled }) => {
    const { t } = useTranslation();
    const [selectedLeave, setSelectedLeave] = useState(null);
    const [isErrorMessage, setIsErrorMessage] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [isFormDisabled, setIsFormDisabled] = useState(isDisabled);
    const [isLoading, setIsLoading] = useState(false);
    const [updateCookies, setUpdateCookies] = useState(convertToCookieString(data.cookies))
    const [updateCSRFToken, setUpdateCSRFToken] = useState(data.csrfToken)
    const [leaves, setLeaves] = useState(data.data
        .filter((leave) => (
            (leave.IsDeletable || leave.IsModifiable)
        )))
    function convertToCookieString(jsonObject) {
        const cookieArray = [];
        for (const [key, value] of Object.entries(jsonObject)) {
            cookieArray.push(`${key}=${value}`);
        }
        return cookieArray.join('; ');
    }
    useEffect(() => {
        setIsFormDisabled(isDisabled)
    }, [isDisabled]);

    const handleEditClick = (leave) => {
        setSelectedLeave(leave);
    };

    function formatDate(dateString) {
        const timestamp = dateString.match(/\d+/)[0];
        const date = new Date(parseInt(timestamp, 10));
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    }

    function formatDateForRequest(dateString) {
        // Create a new Date object using the provided date string
        const date = new Date(dateString);

        // Format the date as YYYY-MM-DDTHH:MM:SS
        const formattedDate = date.toISOString().split('.')[0];

        return formattedDate;
    }

    const handleUpdateLeave = (updatedData, csrfToken, cookies, leaveData, showSubstitution, subCSRFToken, subCookies, substitutions, currentAttachments) => {
        if (updatedData != 'cancel') {
            setIsLoading(true);
            setResponseMessage("");
            setIsFormDisabled(true);

            // Prepare the parameters only with the changed data
            const changedParams = {};
            Object.keys(updatedData).forEach((key) => {
                if (updatedData[key] !== leaveData[key]) {
                    changedParams[key] = updatedData[key];
                }
            });

            let frontendLog = JSON.stringify({
                "sessionID": sessionStorage.getItem('sessionID'),
                "EmployeeID": localStorage.getItem('EmployeeID'),
                "channel": isMobile ? "Mobile" : "Portal",
                "language": localStorage.getItem('language')
            });

            const updateLeaveRequestEndpoint = `${process.env.REACT_APP_BACKEND_URL}/middleware/updateLeaveRequest?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}`;
            const formDataForRequest = new FormData();

            formDataForRequest.append("assertion", localStorage.getItem('id_token'));
            formDataForRequest.append("sessionID", sessionStorage.getItem('sessionID'));
            formDataForRequest.append("language", language);
            formDataForRequest.append("x-csrf-token", csrfToken);
            formDataForRequest.append("cookies", cookies);

            // Append only the changed fields to formDataForRequest
            if (changedParams.leaveType) {
                formDataForRequest.append("AbsenceTypeCode", changedParams.leaveType);
            }
            if (changedParams.fromDate) {
                formDataForRequest.append("StartDate", formatDateForRequest(changedParams.fromDate));
            }
            if (changedParams.toDate) {
                formDataForRequest.append("EndDate", formatDateForRequest(changedParams.toDate));
            }

            if (changedParams.notes) {
                formDataForRequest.append("Notes", changedParams.notes);
            }

            formDataForRequest.append("EmployeeID", localStorage.getItem('EmployeeID'));
            formDataForRequest.append("frontendLog", frontendLog);

            // for sick leave
            if (changedParams.hospital_type) {
                formDataForRequest.append("hospital_type", changedParams.hospital_type);
            }
            if (changedParams.hospital_name) {
                formDataForRequest.append("hospital_name", changedParams.hospital_name);
            }
            if (changedParams.hospital_location !== undefined) {
                formDataForRequest.append("hospital_location", changedParams.hospital_location == "199" ? "X" : "");
            }

            if (updatedData.attachments && updatedData.attachments.length > 0) {
                const startIndex = currentAttachments ? currentAttachments.length + 1 : 1;

                // Add new attachments
                for (let i = 0; i < updatedData.attachments.length; i++) {
                    const file = updatedData.attachments[i];
                    const fileName = file.name;
                    const fileType = file.type;
                    const fileSize = file.size;

                    // Create metadata object for new attachments
                    const attachmentMetadata = {
                        Pernr: "00000000",
                        LeaveRequestId: leaveData.RequestID, // Include the leaveRequestId here
                        FilePath: "",
                        FileName: fileName,
                        FileType: fileType,
                        FileSizeDescr: "",
                        FileSize: fileSize.toString(),
                        FileUrl: "",
                        DeleteEnabled: "",
                        CreaUser: "",
                        CreaDate: null,
                        CreaTime: "",
                        ArchivDocId: "",
                        AttachmentStatus: "E",
                        FileSeqnr: (startIndex + i).toString().padStart(3, '0'),
                        Action: ""
                    };

                    // Append metadata to FormData object
                    formDataForRequest.append(`Attachment${startIndex + i}`, JSON.stringify(attachmentMetadata));
                }
            }

            const params = new URLSearchParams({
                "EmployeeID": localStorage.getItem('EmployeeID'),
                "RequestID": leaveData.RequestID,
                "LeaveKey": leaveData.LeaveKey,
                "ChangeStateID": leaveData.ChangeStateID
            });

            fetch(updateLeaveRequestEndpoint + `&${params}`, {
                method: 'POST',
                body: formDataForRequest
            })
                .then(response => {
                    if (!response.ok) {
                        setIsLoading(false);
                        if (response.status === 400) {
                            return response.json().then(errorData => {
                                setIsErrorMessage(true);
                                setIsFormDisabled(false);
                                setResponseMessage(errorData.errorData[0]);
                                throw new Error('400 Error - Bad Request');
                            });
                        }
                    }
                })
                .then(async (data) => {
                    if (showSubstitution) {
                        callSubstitutionEndpoint(updatedData, leaveData.RequestID, leaveData.LeaveKey, subCSRFToken, subCookies, substitutions, csrfToken, cookies, currentAttachments);
                    } else {
                        await sendAttachments(leaveData.RequestID, leaveData.LeaveKey, csrfToken, cookies, updatedData, currentAttachments);
                        notifyChatbot();
                    }
                })
                .catch(error => {
                    console.error('Error making API request:', error);
                    setIsLoading(false);
                });
        }
        if (updatedData == 'cancel') {
            setIsLoading(false);
            setResponseMessage("");
            setIsFormDisabled(false);
            setSelectedLeave(null); // Close the form after saving or cancelling
        }
    };

    const callSubstitutionEndpoint = (formData, RequestID, LeaveKey, subCSRFToken, subCookies, substitutions, csrfToken, cookies, currentAttachments) => {
        const selectedEmployee = substitutions.find(emp => emp.EmpNum === formData.employee);
        let frontendLog = JSON.stringify({"sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language')})
        const substitutionEndpoint = `${process.env.REACT_APP_BACKEND_URL}/middleware/addSubstitution?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&SubstEmpNum=${selectedEmployee.EmpNum}&SubstituteID=${selectedEmployee.UserID}&BeginDate=${formatDateForRequest(formData.fromDate)}&EndDate=${formatDateForRequest(formData.toDate)}&UserID=${localStorage.getItem('EmployeeID')}&x-csrf-token=${subCSRFToken}&cookies=${subCookies}&token=${localStorage.getItem('id_token')}&sessionID=${encodeURIComponent(sessionStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}`;
  
        fetch(substitutionEndpoint, {
            method: 'POST'
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error creating substitution: ' + response.statusText);
                }
            })
            .then(async (data) => {
                await sendAttachments(RequestID, LeaveKey, csrfToken, cookies, formData, currentAttachments);
                notifyChatbot();
            })
            .catch(error => {
                console.error('Error creating substitution:', error);
                setIsErrorMessage(true);
                setResponseMessage(t("There was an error occured, Please try again."));
                setIsLoading(false);
                setIsFormDisabled(false)
            });
    };

    const sendAttachments = async (RequestID, LeaveKey, csrfToken, cookies, formData, currentAttachments) => {
        let frontendLog = JSON.stringify({
          "sessionID": sessionStorage.getItem('sessionID'),
          "EmployeeID": localStorage.getItem('EmployeeID'),
          "channel": isMobile ? "Mobile" : "Portal",
          "language": localStorage.getItem('language')
        });

        const uploadParams = new URLSearchParams({
          "token": localStorage.getItem('id_token'),
          EmployeeID: localStorage.getItem('EmployeeID'),
          RequestID: RequestID,
          LeaveKey: LeaveKey,
          "x-csrf-token": csrfToken,
          "cookies": cookies,
          "sessionID": sessionStorage.getItem('sessionID'),
          "frontendLog": frontendLog
        }).toString();

        const currentAttachmentCount = currentAttachments ? currentAttachments.length : 0;

        for (let i = 0; i < formData.attachments.length; i++) {
            const file = formData.attachments[i];
            const arrayBuffer = await file.arrayBuffer();

            const fileOrder = currentAttachmentCount + i + 1;

            const fileSlug = `${file.name}|${fileOrder}`;
            
            const uploadResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/sendAttachments?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&${uploadParams}`, {
                method: 'POST',
                headers: {
                    'Content-Type': file.type,
                    'Slug': fileSlug,
                },
                body: arrayBuffer,
            });

            if (!uploadResponse.ok) {
                throw new Error('Error uploading attachment: ' + uploadResponse.statusText);
            }

            const uploadData = await uploadResponse.json();
        }
    };

    
    let frontendLog = {"sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language')}
    const notifyChatbot = () => {
      const requestData = {
          message: t("leave request updated successfully, you need any help?"),
          user_lang: language,
          frontendLog: frontendLog
      };

      fetch(`${process.env.REACT_APP_BACKEND_URL}/chatbot/rephraseMessage?code=${process.env.REACT_APP_CHATBOT_FUNCTION_KEY}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData)
      })
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .then(data => {
        onSendMessage({ sender: 'bot', text: data.message, clearHistory: data.clearHistory });
        setTimeout(() => {
            onSendMessage({
              sender: 'bot',
              isRating: true,
              requestType: data.requestType,
              timestamp: new Date().getTime(),
            });
          }, (process.env.REACT_APP_TIME_TO_DISPLAY_REVIEW * 1000));
        sessionStorage.setItem('clearHistory', true)
        setIsLoading(false);
      })
      .catch(error => {
          console.error('Error making API request:', error);
      });
    }

    const handleDeleteClick = (leave, event) => {
        let hintText = leave.AbsenceTypeName + " (" + formatDate(leave.StartDate) + " - " + formatDate(leave.EndDate) + ")" 
        const closestTableContainer = event.target.closest('.chat-body');
        Swal.fire({
            title: t('Are you sure you want to delete?'),
            text: hintText,
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#891638',
            cancelButtonColor: '#fff',
            confirmButtonText: t('Yes'),
            cancelButtonText: t('Cancel'),
            position: 'bottom',
            backdrop: 'rgba(0, 0, 0, 0)',
            customClass: {
                popup: 'custom-swal-size',
                confirmButton: 'custom-confirm-button',
                cancelButton: 'custom-cancel-button',
                title: 'custom-title-font',
                htmlContainer: 'custom-text-font',
            },
            target: closestTableContainer,
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                // Assuming you have the necessary data from the 'leave' object passed into the function
                const { RequestID, ChangeStateID, LeaveKey } = leave;
                let frontendLog = JSON.stringify({
                    "sessionID": sessionStorage.getItem('sessionID'),
                    "EmployeeID": localStorage.getItem('EmployeeID'),
                    "channel": isMobile ? "Mobile" : "Portal",
                    "language": localStorage.getItem('language')
                });

                fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/deleteLeave?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&EmployeeID=${localStorage.getItem('EmployeeID')}&RequestID=${RequestID}&ChangeStateID=${ChangeStateID}&LeaveKey=${encodeURIComponent(LeaveKey)}&token=${localStorage.getItem('id_token')}&sessionID=${sessionStorage.getItem('sessionID')}&frontendLog=${frontendLog}&csrfToken=${updateCSRFToken}&language=${language}&cookies=${encodeURIComponent(updateCookies)}`, {
                    method: 'DELETE',
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        setLeaves((prevLeaves) => prevLeaves.filter(l => l.RequestID !== RequestID));
                        Swal.fire({
                            text: t('Leave has been deleted.'),
                            icon: 'success',
                            position: 'bottom',
                            backdrop: 'rgba(0, 0, 0, 0)',
                            confirmButtonText: t("OK"),
                            customClass: {
                                popup: 'custom-swal-size',
                                title: 'custom-title-font',
                                htmlContainer: 'custom-text-font',
                            },
                            target: closestTableContainer,
                        });
                        setIsLoading(false);
                    } else {
                        Swal.fire({
                            text: data.errorData[0],
                            icon: 'error',
                            position: 'bottom',
                            backdrop: 'rgba(0, 0, 0, 0)',
                            confirmButtonText: t("OK"),
                            target: closestTableContainer,
                            customClass: {
                                popup: 'custom-swal-size',
                            }
                        });
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    Swal.fire({
                        title: t('Error!'),
                        text: data.errorData[0],
                        icon: 'error',
                        position: 'bottom',
                        backdrop: 'rgba(0, 0, 0, 0)',
                        confirmButtonText: t("OK"),
                        target: closestTableContainer,
                        customClass: {
                            popup: 'custom-swal-size',
                        }
                    });
                    setIsLoading(false);
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        });
    };
    

    return (
        <div className={`update-leave-container w-100 ${isFormDisabled ? 'disabled-class' : ''}`}>
            {isLoading &&
                <div className='centered-v-h loading-overlay'>
                    <img className="img-bottom" src={loadingGif} alt="Loading..." width={70} height={70} />
                    <span className="span-bottom">{t('Processing, please wait ...')}</span>
                </div>
            }
            {selectedLeave ? (
                <UpdateLeaveForm
                    leaveData={selectedLeave}
                    language={language}
                    isFormDisabledProp={isFormDisabled}
                    onUpdateLeave={handleUpdateLeave}
                    responseMessage={responseMessage}
                    isErrorMessage={isErrorMessage}
                    setIsParentLoading={setIsLoading}
                    setResponseMessage={setResponseMessage}
                />
            ) : (
                data.data && data.data.length > 0 ? (
                    <> 
                        <ul className='update-leave-list'>
                            {leaves
                                .filter((leave) => (
                                    ["0100", "0105", "0106", "0261", "0262", "0263", "0322", "0367", "0130", "0160", "0330", "0170", "0380", "0180", "0360", "0190", "0200", "0210", "0220", "0230", "0240", "0250", "0260", "0270", "0280", "0285", "0290", "0291", "0300", "0320", "0610"].includes(leave.AbsenceTypeCode)
                                ))
                                .map((leave, index) => (
                                    <li className='update-leave-list-item' key={index}>
                                        <div className='update-leave-list-item-header'>
                                            <div className='update-leave-list-item-header-title'>{leave.AbsenceTypeName}</div>
                                            <div className='update-leave-list-item-header-actions'>
                                                {(leave.IsModifiable && leave.StatusID !== "SENT") ? (
                                                    <>
                                                        <button onClick={() => handleEditClick(leave)} className='edit' disabled={isFormDisabled}>
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        {leave.IsDeletable &&
                                                            <button onClick={(e) => handleDeleteClick(leave, e)} className='delete' disabled={isFormDisabled}>
                                                                <FontAwesomeIcon icon={faTrashCan} />
                                                                {/* <i class="fa-regular fa-trash-can"></i> */}
                                                            </button>}
                                                    </>
                                                ) : (
                                                    <>
                                                        {
                                                            leave.IsDeletable &&
                                                            <button onClick={(e) => handleDeleteClick(leave, e)} className='delete' disabled={isFormDisabled}>
                                                                <FontAwesomeIcon icon={faTrashCan} />
                                                            </button>
                                                        }
                                                    </>
                                                )
                                                }

                                            </div>
                                        </div>
                                        <div className='update-leave-list-item-body'>
                                            <div className='update-leave-list-item-body-container'>
                                                <div className='update-leave-list-item-body-label'>تاريخ البداية</div>
                                                <div className='update-leave-list-item-body-value'>{formatDate(leave.StartDate)}</div>
                                            </div>
                                            <div className='update-leave-list-item-body-container'>
                                                <div className='update-leave-list-item-body-label'>تاريخ الانتهاء</div>
                                                <div className='update-leave-list-item-body-value'>{formatDate(leave.EndDate)}</div>
                                            </div>
                                            <div className='update-leave-list-item-body-container'>
                                                <div className='update-leave-list-item-body-label'>الحالة</div>
                                                <div className='update-leave-list-item-body-value'>
                                                    <span className={
                                                        (leave.StatusID === "APPROVED" || leave.StatusID === "POSTED") ? "badge success" :
                                                            leave.StatusID === "SENT" ? "badge warning" :
                                                                "badge default" // fallback for unknown statuses
                                                    }>
                                                        {leave.StatusTxt}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}

                        </ul>
                    </>
                ) : (
                    <p>{t("Sorry, you don't have any leave records.")}</p>
                )
            )}
        </div>
    );
};

export default UpdateLeave;
